import { CommonModule } from '@angular/common';
import { Component, HostBinding } from '@angular/core';
import { SessionService } from '../session.service';
import { SpaceWizardResultComponent } from './space.wizard.result.component';

@Component({
  selector: 'app-space-wizard-result-page',
  standalone: true,
  imports: [CommonModule, SpaceWizardResultComponent],
  templateUrl: './space.wizard.result.page.html',
})
export class SpaceWizardResultPage {
  @HostBinding('class') css = 'max-scroll';
  constructor(private session: SessionService) {}
  ngOnInit() {}
  _common = _common;
}
